<template>
  <div class="container ">
    <div
      class="row justify-content-center align-items-center"
      style="
        
        "
    >
      <div class="card">
        <div class="card-header">
          <img src="../img/logo.png" class="rounded" alt="" />
        </div>
        <div class="card-body">
          <form action="" @submit.prevent="submit">
            <div class="form-group ">
              <label for="">اسم المستخدم</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.username.$model"
                :class="{
                  'is-invalid': $v.username.$error,
                  'is-valid': !$v.username.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.username.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.username.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.username.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.username.maxLength"
                  >اقصى عدد مسموح {{ $v.username.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>
            <div class="form-group ">
              <label for="">كلمة المرور</label>
              <input
                type="password"
                class="form-control"
                v-model.trim="$v.password.$model"
                :class="{
                  'is-invalid': $v.password.$error,
                  'is-valid': !$v.password.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.password.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.password.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.password.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.password.maxLength"
                  >اقصى عدد مسموح {{ $v.password.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>
            <div class="card-footer">
              <dir class="row">
                <div class="col-6 text-left">
                  <button
                    class="btn btn-success"
                    type="submit"
                    :disabled="submitStatus === 'انتظار'"
                  >
                    <i class="fa fa-paper-plane"></i>
                    <span> {{ submitStatus }} </span>
                    <b-spinner
                      v-if="busy"
                      small
                      type="grow"
                      style="margin-bottom: 3px;"
                    ></b-spinner>
                  </button>
                </div>
                <div class="col-6 text-right">
                  <b-button class="btn btn-info" type="button" @click="clear()">
                    <i class="fa fa-undo"></i>
                    <span> الغاء </span>
                  </b-button>
                </div>
                <div class="col-12 text-center text-danger pt-3" v-show="error">
                  يوجد خطأ فى اسم المستخدم او كلمة المرور
                </div>
              </dir>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import loginLayout from "../layouts/loginLayout.vue";
export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      error: false,
      busy: false,
      submitStatus: "دخول",
    };
  },
  created() {
    localStorage.clear();
    this.$emit("update:layout", loginLayout);
  },
  validations: {
    username: { required, minLength: minLength(2), maxLength: maxLength(25) },
    password: { required, minLength: minLength(2), maxLength: maxLength(25) },
  },
  methods: {
    async submit() {
      this.$v.$touch();
      this.busy = true;
      if (this.$v.$invalid) {
        this.submitStatus = "خطأ";
        this.busy = false;
      } else {
        var logn = {
          email: this.username,
          password: this.password,
        };
        //  await  this.$store.actions('login',logn);
        await this.$store
          .dispatch("loginAction", logn)
          .then((res) => {
            if (res.data.status == "success") {
              this.busy = false;
              this.$router.push("/Home");
            } else {
              this.busy = false;
              this.submitStatus = "خطأ";
              this.error = true;
            }
          })
          .catch((err) => {
            this.busy = false;
            this.submitStatus = "خطأ";
            this.error = true;

            console.log(err);
          });

        setTimeout(() => {
          this.submitStatus = "دخول";
        }, 500);
      }
    },
    clear() {
      this.username = "";
      this.password = "";
      this.error = false;
      this.$v.$reset();
    },
  },
};
</script>

<style scoped>
.card {
  width: 35%;
  height: 420px;
  margin-top: 10%;
}
.card-header {
  background-color: transparent;
  text-align: center;
  border-bottom: 0;
}
.card-footer {
  padding: 0 !important;
  border-top: 0;
}
.row {
  padding: 0;
}
</style>
